export default {
    carregando: false,
    items: [],
    selecionado: {},
    paginacao: null
}